//Utilitario para el Api Transactional

import { esListaNoVacia } from "./arrayUtils";

/**
 * Function que permite generar un request para generar clave de doble factor
 * @returns
 */
export const buildGenerarClaveDobleFactorRequest = (
  tipoProceso,
  claveDobleFactorUsuario
) => {
  return {
    tipoProceso: tipoProceso,
    tipoClave: getCodigoTipoClaveDobleFactorPrincipalUsuario(
      claveDobleFactorUsuario
    ),
  };
};

/**
 * Function que permite obtener la clave de doble factor principal del usuario
 * @param {*} claveDobleFactorUsuario
 * @returns
 */
export const getClaveDobleFactorPrincipalUsuario = (
  claveDobleFactorUsuario
) => {
  if (!esListaNoVacia(claveDobleFactorUsuario.lista)) return;

  return claveDobleFactorUsuario.lista.find(
    (claveDobleFactor) => claveDobleFactor.principal
  );
};

/**
 * Function que permite obtener el tipo de clave de doble factor principal del usuario
 * @param {*} claveDobleFactorUsuario
 * @returns
 */
export const getTipoClaveDobleFactorPrincipalUsuario = (
  claveDobleFactorUsuario
) => {
  if (!esListaNoVacia(claveDobleFactorUsuario.lista)) return;
  return claveDobleFactorUsuario.lista.find(
    (claveDobleFactor) => claveDobleFactor.principal
  ).tipoClaveDobleFactor;
};

/**
 * Function que permite obtener el codigo del tipo clave de doble factor principal del usuario
 * @param {*} claveDobleFactorUsuario
 * @returns
 */
export const getCodigoTipoClaveDobleFactorPrincipalUsuario = (
  claveDobleFactorUsuario
) => {
  if (!esListaNoVacia(claveDobleFactorUsuario.lista)) return;
  return claveDobleFactorUsuario.lista.find(
    (claveDobleFactor) => claveDobleFactor.principal
  ).tipoClaveDobleFactor.codigo;
};

/**
 * Function que permite generar un request para validar clave de doble factor
 * @returns
 */
export const buildValidarClaveDobleFactorRequest = (
  claveDobleFactorUsuario,
  clave
) => {
  if (!esListaNoVacia(claveDobleFactorUsuario.lista)) return;
  return {
    tipoClave: getCodigoTipoClaveDobleFactorPrincipalUsuario(
      claveDobleFactorUsuario
    ),
    clave,
  };
};
